// extracted by mini-css-extract-plugin
export default {"user":"UserPage_user__bjufL","container":"UserPage_container__HQD+R"};